import {ChangeDetectionStrategy, Component, input, output} from '@angular/core';
import {ComputedLp} from '../../../../components/dex/dex-streaming/types/computed/computed-lp';
import {ComputedTranche} from '../../../../components/dex/dex-streaming/types/computed/computed-tranche';
import {
    DexLpDetailsStandaloneComponent
} from '../../standalone/dex-lp-details-standalone/dex-lp-details-standalone.component';

@Component({
    selector:      'dex-lp-details-part',
    templateUrl:   './dex-lp-details-part.component.html',
    styleUrls:     ['./dex-lp-details-part.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports:       [
        DexLpDetailsStandaloneComponent
    ]
})
export class DexLpDetailsPartComponent {
    public readonly lp = input.required<ComputedLp | null>();
    public readonly tranches = input.required<ComputedTranche[]>();
    public readonly isCollapsed = input.required<boolean>();
    public readonly isSymbolClickable = input.required<boolean>();

    public readonly toggleCollapsed = output<void>();
    public readonly symbolClick = output<string>();
}
